module.exports = __webpack_public_path__ + "img/header-logo1.43f4b2cb.png";